export default __webpack_public_path__ + "static/ls-kitchener-f80d258a8f7afa982b3975721497a5d6.jpg";